import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/dashboard/summary';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* fetchDashboardSummary() {
  try {
    const response = yield call(
      axios.get,
      `${config.API_URL}/dashboard/summary`,
      { headers: getLocalUser() },
    );
    // core wraps payloads under ``{ data: ... }``.
    const body = response?.data?.data ?? response?.data ?? {};
    yield put(fetchSuccess(body));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, fetchDashboardSummary);
}
